








































































































































































import { Watch, Component, Vue } from 'vue-property-decorator'
import { vxm } from '@/store/'
import { accessContext } from '@/eostransit'
import { DiscoveryData, WalletProvider } from 'eos-transit'

@Component({
  props: {},
  components: {}
})
export default class TransitAuth extends Vue {
  walletProviders: WalletProvider[] = accessContext.getWalletProviders()
  walletProvider: WalletProvider | undefined
  wallet: any
  discoveryData: DiscoveryData | undefined

  get isAuthenticated() {
    return (
      vxm.transit.walletState.authenticated &&
      !vxm.transit.walletState.authenticationError
    )
  }

  get isMobile() {
    return vxm.core.isMobile
  }

  get isAlertShow() {
    return (
      vxm.transit.walletState.authenticating ||
      vxm.transit.walletState.connecting
    )
  }

  get getWalletLogo() {
    switch (this.wallet.provider.id) {
      case 'scatter': {
        return require('@/assets/media/logos/scatter.svg')
      }
      case 'EOS Lynx': {
        return require('@/assets/media/logos/lynx.jpg')
      }
      case 'meetone_provider': {
        return require('@/assets/media/logos/meetone.jpg')
      }
      case 'TokenPocket': {
        return require('@/assets/media/logos/tp.jpg')
      }
      default: {
        return require('@/assets/media/logos/scatter.svg')
      }
    }
  }

  async initTransit(walletId: string) {
    this.walletProvider = this.walletProviders.find(r => {
      return r.id === walletId
    })
    if (this.walletProvider !== undefined) {
      this.wallet = accessContext.initWallet(this.walletProvider)
    }
    //Subscrible to Transit wallet changes and bind it to a vue variable
    this.wallet.subscribe((walletState: any) => {
      if (walletState) vxm.transit.setWalletState(walletState)
    })
    await this.wallet.connect()
    try {
      //if wallet does not provide public keys (eg. scatter), proceed to login
      if (walletId !== 'ledger') {
        await this.wallet.login()
        try {
          vxm.transit.setWallet(this.wallet)
        } catch (ex) {
          console.error('Login Error:')
          console.log(ex)
        }
      }
      //if wallet provides one or more public keys (eg. ledger), allow user to choose desired account
      else {
        vxm.transit.setWallet(this.wallet)
        //start public key discovery for first index
        let more = true
        let i = 0
        while (more) {
          this.discoveryData = await this.wallet.discover({
            pathIndexList: [i]
          })
          if (
            this.discoveryData &&
            this.discoveryData.keyToAccountMap[i].accounts.length === 0
          ) {
            more = false
          }
          i++
        }
        if (
          this.discoveryData &&
          this.discoveryData.keyToAccountMap.length > 0
        ) {
          vxm.modals.setLedgerModal(this.discoveryData)
          this.$bvModal.show('modal-ledger')
        }
      }
    } catch (ex) {
      console.error('Connection Error:')
      console.log(ex)
      vxm.alerts.setAlert({
        show: true,
        dismissible: true,
        title: 'Connection Error!',
        message:
          'Could not connect to your Wallet. Make sure your Wallet is unlocked. If using Ledger, make sure your Ledger is plugged in and the EOS App open.',
        variant: 'danger',
        dismissSecs: 8,
        dismissCountDown: 8
      })
    }
  }

  logout() {
    vxm.transit.logout()
  }

  // Lifecycle hooks
  created() {
    const autoLogin = localStorage.autoLogin
    if (autoLogin && vxm.core.settings.autoLogin) {
      this.initTransit(autoLogin)
    }
  }
  mounted() {}
  updated() {}
  destroyed() {}
}
